<template>
  <CCard class="question__card">
    <CCardHeader> سوال {{ question.index + 1 }}</CCardHeader>
    <CCardBody class="d-flex align-items-start h-100">
      <div v-if="imagePreview" class="image-preview">
        <div class="bg-shadow"></div>
        <img :src="imagePreview" class="" @click="imagePreview = null"/>
      </div>
      <CForm class="w-100">
        <div class="mb-4 question__title">
          <span class="bold">سوال:</span>{{ question.text }}
        </div>

        <div v-if="filterVideos" class="flex-fill">
          <video class="media-video__wrapper" controls>
            <source v-if="question.fileUrl" :src="question.fileUrl"/>
          </video>
        </div>
        <div v-else-if="filterAudios" class="flex-fill">
          <audio class="media-audio__wrapper" controls>
            <source v-if="question.fileUrl" :src="question.fileUrl"/>
          </audio>
        </div>
        <div
            v-else-if="filterImages"
            class="media-image__wrapper flex-fill mx-2"
        >
          <img
              v-if="question.fileUrl"
              :src="question.fileUrl"
              alt=""
              @click="imagePreview = question.fileUrl"
          />
        </div>

        <div v-else-if="question.fileUrl" class="download-file ml-3 my-2">
          <a :href="question.fileUrl" download="" target="_blank">
            <CIcon name="cil-file"/>
          </a>
        </div>

        <div class="d-flex flex-column justify-content-center">
          <div
              v-for="(choice, index) in question.choices"
              :key="index"
              class="mt-4 d-flex align-items-center"
          >
            <CInputRadio
                v-if="choice !== ''"
                :checked="form.text === choice"
                name="choices"
                @update:checked="form.text = choice"
            >
              <template #label>
                <img
                    v-if="choice.includes('http')"
                    :src="choice"
                    class="choice-image"
                    @click="imagePreview = choice"
                />

                <div v-else>{{ choice }}</div>
              </template>
            </CInputRadio>
          </div>
        </div>
      </CForm>
    </CCardBody>
    <CCardFooter class="d-flex align-items-center justify-content-end">
      <CButton
          v-if="question.last"
          class="px-sm-5 py-sm-2"
          color="primary"
          @click="addSolution"
      >
        پایان آزمون
      </CButton>
      <CButton
          v-else
          class="px-sm-5 py-sm-2"
          color="primary"
          @click="addSolution"
      >
        سوال بعدی
      </CButton>
    </CCardFooter>
    <ExamFinishModal v-model="examFinishModal"/>
  </CCard>
</template>

<script>
import ExamFinishModal from "../Modals/Exam/ExamFinishModal.vue";

export default {
  components: {ExamFinishModal},
  props: {
    question: {
      type: Object,
    },
  },
  data() {
    return {
      form: {text: ""},
      examFinishModal: false,
      imagePreview: null,
    };
  },
  computed: {
    filterImages() {
      return this.question.fileUrl
          ? this.question.fileUrl.toLowerCase().includes("jpg")
          : "" || this.question.fileUrl
              ? this.question.fileUrl.toLowerCase().includes("png")
              : "" || this.question.fileUrl
                  ? this.question.fileUrl.toLowerCase().includes("jpeg")
                  : "" || this.question.fileUrl
                      ? this.question.fileUrl.toLowerCase().includes("bmp")
                      : "" || this.question.fileUrl
                          ? this.question.fileUrl.toLowerCase().includes("tiff")
                          : "" || this.question.fileUrl
                              ? this.question.fileUrl.toLowerCase().includes("gif")
                              : "" || this.question.fileUrl
                                  ? this.question.fileUrl.toLowerCase().includes("svg")
                                  : "";
    },
    filterVideos() {
      return this.question.fileUrl
          ? this.question.fileUrl.toLowerCase().includes("mp4")
          : "" || this.question.fileUrl
              ? this.question.fileUrl.toLowerCase().includes("mkv")
              : "" || this.question.fileUrl
                  ? this.question.fileUrl.toLowerCase().includes("avi")
                  : "" || this.question.fileUrl
                      ? this.question.fileUrl.toLowerCase().includes("mov")
                      : "" || this.question.fileUrl
                          ? this.question.fileUrl.toLowerCase().includes("webm")
                          : "" || this.question.fileUrl
                              ? this.question.fileUrl.toLowerCase().includes("flv")
                              : "";
    },
    filterAudios() {
      return this.question.fileUrl
          ? this.question.fileUrl.toLowerCase().includes("mp3")
          : "" || this.question.fileUrl
              ? this.question.fileUrl.toLowerCase().includes("ogg")
              : "" || this.question.fileUrl
                  ? this.question.fileUrl.toLowerCase().includes("m4a")
                  : "" || this.question.fileUrl
                      ? this.question.fileUrl.toLowerCase().includes("aac")
                      : "" || this.question.fileUrl
                          ? this.question.fileUrl.toLowerCase().includes("wav")
                          : "";
    },
  },
  methods: {
    addSolution() {
      this.$emit("add-solution", this.form);
      this.form = {text: ""};
    },
  },
};
</script>

<style lang="scss" scoped>
.question__title {
  overflow-wrap: break-word;
  white-space: pre-line;
}

::v-deep {
  .form-check {
    display: flex;
    align-items: center;
    width: 100%;

    .form-check-input {
      width: 24px;
      height: 24px;
      position: static;
      margin-top: 0;
      margin-left: 8px;
    }
  }
}

.media-image__wrapper {
  position: relative;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 8px;
    @media (max-width: 768px) {
      min-width: 100%;
      max-width: 100%;
    }
  }
}

.media-video__wrapper {
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.media-audio__wrapper {
  position: relative;
}

.choice-image {
  height: 150px;
  width: auto;
  max-width: calc(100% - 50px);
  object-fit: contain;
  border-radius: 8px;
  cursor: pointer;

}

.image-preview {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  justify-content: center;
  width: 100vw;
  max-height: 100vh;

  .bg-shadow {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: #000000cc;
  }

  img {
    width: 90%;
    height: auto;
    object-fit: contain;
    z-index: 3000;
  }
}
</style>